/**
 * @file
 * Defines Javascript behaviors for the cookies consent.
 */
;

class TUCCookiesConsent {
  constructor() {
    this.isFirstTime = false;

    this.bindEvents();

    this.userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if (this.userTrackingConsent === 'no_interaction') {
      // No preference saved, open cookie banner
      this.isFirstTime = true;
      this.openBanner();
    } else {

      // Load saved values
      this.updatePreferencesCheckboxesValues();
    }
  }

  bindEvents() {

    document.addEventListener("visitorConsentCollected", ((e) => {
      if (e.detail.analyticsAllowed == false) {
        this.deleteAnalyticsCookies();
      } else {
        this.allowAnalyticsCookies();
      }

      if (e.detail.marketingAllowed == false) {
        this.deleteMarketingCookies();
      } else {
        this.allowMarketingCookies();
      }
    }));

    $('[data-market="ca"] [data-handle="do-not-sell-or-share-my-personal-information"]').parent().remove();

    $(document).on("click", 'a[href*="#cookies-preferences"]', function (e) {
      this.openBanner();
    }.bind(this))

    $('[data-cc="grant-all"]').on('click', (e) => {
      e.preventDefault();
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: true,
        marketing: true,
        preferences: true,
        sale_of_data: true
      }, this.updatePreferencesCheckboxesValues);

      this.closeAll();
    });

    $('[data-cc="deny-all"]').on('click', (e) => {
      e.preventDefault();

      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: false,
        marketing: false,
        preferences: false,
        sale_of_data: false
      }, () => {
        this.closeAll();
        // location.reload();
      });
    });

    $(document).on('click', '[data-cc="preferences"]', (e) => {
      e.stopImmediatePropagation();
      const showBackButton = $(e.currentTarget).data("cc-show-back-btn")
      this.openPreferences(showBackButton);
    });

    $('[data-cc="save-preferences"]').on('click', (e) => {
      e.preventDefault();
      let needsRefresh = false;

      let newConsent = {
        analytics: false,
        marketing: false,
        preferences: false,
        sale_of_data: false
      };

      $(".cookies-preferences .service-item input[type='checkbox']").each(function (i, el) {
        const id = $(el).attr("id");

        if (typeof newConsent[id] !== "undefined") {
          let isGranted = $(el).is(":checked");
          newConsent[id] = isGranted;

          if (!isGranted) {
            needsRefresh = true;
          }
        }
      });

      window.Shopify.customerPrivacy.setTrackingConsent(newConsent, () => {
        this.closeAll();
        // if (needsRefresh) location.reload();
      });

    });

    $('[data-cc="close-preferences"]').on('click', (e) => {
      e.preventDefault();
      this.openBanner();
    });

    $('a[href="#cookie-settings"]').on('click', (e) => {
      e.preventDefault();
      this.openPreferences();
    });

    $('#cookies .cookies-preferences .service-item .service-infos').on('click', (e) => {
      e.preventDefault();
      const relatedCheckbox = $(e.currentTarget).parent().find(".service-toggle input");
      if (relatedCheckbox.is(':checked') && !relatedCheckbox.attr("disabled")) {
        relatedCheckbox.prop("checked", false);
      } else {
        relatedCheckbox.prop("checked", true);
      }
    });
  }

  openBanner() {
    this.closePreferences().then(() => {
      $("#cookies").removeClass("out").addClass("active");
      $("#cookies .cookies-banner").addClass("active out");
      requestAnimationFrame(() => {
        setTimeout(() => {
          $("#cookies .cookies-banner").removeClass("out")
        }, 20);
      });
    });

    UnscentedCoApp.enablePopup($("#cookies"));

    setTimeout(function (){
      $('#cookies .cookies-settings').focus();
    }, 500)
  }

  closeBanner() {
    return new Promise((resolve) => {
      $("#cookies .cookies-banner").addClass("out");
      if ($("#cookies .cookies-banner").hasClass("active")) {
        setTimeout(() => {
          $("#cookies .cookies-banner").removeClass("active")
          resolve();
        }, 250);
      } else {
        resolve()
      }
    })
  }

  openPreferences(showBackButton) {
    this.closeBanner().then(() => {
      $("#cookies .cookies-back-trigger").toggleClass("hidden", (showBackButton !== true))

      // this.updatePreferencesCheckboxesValues();

      $("#cookies").removeClass("out").addClass("active");
      $("#cookies .cookies-preferences").addClass("active out");
      requestAnimationFrame(() => {
        setTimeout(() => {
          $("#cookies .cookies-preferences").removeClass("out")
        }, 20);
      });
    });
  }

  closePreferences() {
    return new Promise((resolve) => {
      $("#cookies .cookies-preferences").addClass("out");
      if ($("#cookies .cookies-preferences").hasClass("active")) {
        setTimeout(() => {
          $("#cookies .cookies-preferences").removeClass("active")
          resolve();
        }, 250);
      } else {
        resolve()
      }
    })

    UnscentedCoApp.disablePopup($("#cookies"));
  }

  closeAll() {
    $("#cookies").addClass("out");
    Promise.all([
      this.closeBanner(),
      this.closePreferences(),
    ]).then(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          $("#cookies").removeClass("active out");
        }, 250);
      })
    })

    UnscentedCoApp.disablePopup($("#cookies"));

    if(this.isFirstTime){
      // A third-party modal (e.g. Klaviyo quiz) may be open behind the banner, send focus back into it
      const $otherDialogFocusable = $('[role="dialog"][aria-modal="true"]:visible')
        .not('#cookies [role="dialog"]')
        .first()
        .find(UnscentedCoApp.focusableEls)
        .filter(':visible')
        .first();

      if ($otherDialogFocusable.length) {
        $otherDialogFocusable.focus();
      } else {
        $('.skip-to-content-link').focus();
      }
    }
  }

  updatePreferencesCheckboxesValues() {
    try {
      // get current visitor settings
      const currentConsent = window.Shopify.customerPrivacy.currentVisitorConsent();

      for (const [key, value] of Object.entries(currentConsent)) {
        let isEnabled = value == "yes";
        $('#cookies .cookies-preferences .service-item input[id=' + key + ']').prop("checked", isEnabled);
      }
    } catch (e) {
      console.error(e)
    }
  }

  allowAnalyticsCookies() {
    // Allow Clarity
    window.clarity('consent');
  }

  deleteAnalyticsCookies() {
    // Prevent Clarity from using cookie
    window.clarity('consent', false);

    const currentCookies = Cookies.get();

    for (var name in currentCookies) {
      if (
        name.startsWith("_ga") || name.startsWith("_gid") // Google analytics
        || name.startsWith("_pin") || name == "_derived_epik" // Pinterest
        || name.startsWith("_fbp") || name.startsWith("_fbc") // FB Pixel
        || name.startsWith("_clck") || name.startsWith("_clsk") // Microsoft Clarity
      ) {
        Cookies.remove(name, {path: '/', domain: document.domain});
        Cookies.remove(name, {path: '/'});
        Cookies.remove(name);
      }
    }
  }

  allowMarketingCookies() {
    // Allow Klaviyo ad personalization
    if (typeof window.klaviyo !== "undefined" && window.klaviyo.isIdentified()) {
      window.klaviyo.push(['identify', {
        'ad_personalization': "granted",
        'ad_user_data': "granted",
      }]);
    }
  }


  deleteMarketingCookies() {
    // Prevent Klaviyo ad personalization
    if (typeof window.klaviyo !== "undefined" && window.klaviyo.isIdentified()) {
      window.klaviyo.push(['identify', {
        'ad_personalization': "denied",
        'ad_user_data': "denied",
      }]);
    }

    const currentCookies = Cookies.get();

    for (var name in currentCookies) {
      if (
        name.startsWith("__kla_id") // Klaviyo
      ) {
        Cookies.remove(name, {path: '/', domain: document.domain});
        Cookies.remove(name, {path: '/'});
        Cookies.remove(name);
      }
    }
  }
}
